import { useEditableTableContext } from "./EditableTableContext";

export const useHeaderSelection = <T>(numberOfCellsPerLine: number) => {
    const {
        selectedArea,
        setSelectedArea,
        combineWithExistingSelectedArea,
        targetLines,
        headerRef,
    } = useEditableTableContext<T>();

    const setSelectedAreaForColumn = (
        event: React.MouseEvent,
        column: number,
    ) => {
        const isFirstCell = column === 0;

        const newArea = {
            topLeftCellPosition: {
                columnIndex: column,
                rowIndex: 0,
            },
            bottomRightCellPosition: {
                columnIndex: isFirstCell ? numberOfCellsPerLine : column,
                rowIndex: targetLines.length - 1,
            },
        };

        if (event.shiftKey) {
            combineWithExistingSelectedArea(
                newArea.topLeftCellPosition,
                newArea.bottomRightCellPosition,
            );
        } else {
            setSelectedArea(
                newArea.topLeftCellPosition,
                newArea.bottomRightCellPosition,
            );
        }
    };

    const isFullColumnSelected = (columnIndex: number) => {
        if (!selectedArea) {
            return false;
        }
        return (
            columnIndex >= selectedArea.topLeftCellPosition.columnIndex &&
            columnIndex <= selectedArea.bottomRightCellPosition.columnIndex &&
            selectedArea.topLeftCellPosition.rowIndex === 0 &&
            selectedArea.bottomRightCellPosition.rowIndex ===
                targetLines.length - 1
        );
    };

    return { setSelectedAreaForColumn, isFullColumnSelected, headerRef };
};
